import ModuleHeader from "../../components/ModuleHeader/ModuleHeader";

const tabs = [
  // {
  //   id: "overview",
  //   title: "Overview",
  //   icon: "ri-line-chart-line",
  //   path: "/reports",
  // },

  {
    id: "crdrreport",
    title: "Credit/ Debit Report",
    icon: "ri-calendar-event-line",
    path: "/reports/credit/debit",
  },
  // {
  //   id: "feereport",
  //   title: "Fee Report",
  //   icon: "ri-currency-line",
  //   path: "/report/fee/transactions",
  // },

  {
    id: "expensereport",
    title: "Expense Report",
    icon: "ri-money-dollar-circle-line",
    path: "/reports/expense/report",
  },

  {
    id: "feeduesreport",
    title: "Fee Dues Report",
    icon: "ri-file-list-3-line",
    path: "/reports/fee/due",
  },

  {
    id: "staffreport",
    title: "Staff Report",
    icon: "ri-user-line",
    path: "/reports/staff/report",
  },
];

export default function ReportLayout({ children }) {
  return (
    <>
      <ModuleHeader tabs={tabs} />

      {children}
    </>
  );
}
